module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_vm._v("Dear Reader,")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("If you have not read anything about "), _c('em', [_vm._v("Danilo and the Chocolate Hills")]), _vm._v(", then before you read even one more sentence, you should know this: Danilo is a good boy, however, his decision to skip school and go along with his good friend Carlo to the Chocolate Hills on the Island of Bohol, sets off a dramatic saga when the Evil Giant of the Hills turned them both into tarsiers. The tarsier is a small species of primate that is found inhabiting the well-vegetated forests on some islands in southeast Asia, including the Island of Bohol in the Philippines.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("After almost two months, a monkey saved Danilo when she moved him away from the Hills to her colony and was able to purify him through moonlight bathing at the seaside. When he got to be a boy again, he was able to go back to his family on the back of a dolphin friend named Paco. Back with his family, Danilo was determined to save his good friend Carlo from the Evil Giant of the Chocolate Hills.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("What we have learned from the second book of this series, after inspiring adventures that were full of unusual situations, challenges, sacrifices, twists, and turns, Carlo was saved through the help of his friend Danilo, his unexpected friend Paco—the dolphin, and a monkey and her family who were able to save him from the Evil Giant of the Chocolate Hills through unusual adventure that was full of dangerous encounters.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1.5em"
    }
  }, [_vm._v("This third and final book of the series of "), _c('em', [_vm._v("Danilo and the Chocolate Hills")]), _vm._v(" will continue to take you through unexpected situations, adventures, and uncommon incidents that young Danilo and his determined friend Carlo look everywhere searching to find their dolphin friend ‘Paco’ and face off against the Evil Giant of the Chocolate Hills in a very unprecedented adventure.")]), _vm._v(" "), _c('p', [_vm._v("With all due respect,")]), _vm._v(" "), _c('p', [_vm._v("Issam A. Ghazzawi")]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "img-centre",
    staticStyle: {
      "width": "4.41635in",
      "height": "3.41456in"
    },
    attrs: {
      "alt": "",
      "src": "media/file0.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258a58b9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 72
// module chunks = 0